import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { LayoutWrapper } from "@/components/layout-wrapper";
import { DocumentTitle } from "@/components/common/DocumentTitle";
import { SITE_TITLE } from "@/lib/pageTitle";
import { usePointerEventsGuard } from "@/hooks/use-pointer-events-guard";
import { publicRoutes } from "./routes/publicRoutes";
import { protectedRoutes } from "./routes/protectedRoutes";
import { TrialAttributionCapture } from "@/components/trial-attribution-capture";

const NotFound = () => (
  <div style={{ padding: 24 }}>
    <Helmet>
      <title>{`404 | ${SITE_TITLE}`}</title>
    </Helmet>
    <h1>404 Not Found</h1>
  </div>
);

// LayoutWrapper を最上位に置くことで、すべてのルート (public / protected) で
// AuthChecker / cachedUserInfo に基づく認証ガードと、初期トークン検証時の
// グローバル overlay 等が一度だけ動く。
// Next.js 時代は src/app/layout.tsx (root layout) が同じ役割を担っていた。
export const App = () => {
  // 削除確認などモーダル閉鎖後に body の pointer-events: none が残留して
  // 画面全体が操作不能になる問題への全画面ガード
  usePointerEventsGuard();
  return (
    <LayoutWrapper>
      {/* ルートごとの document.title（ページ側は無変更で全画面に効く） */}
      <DocumentTitle />
      <TrialAttributionCapture />
      <Routes>
        {publicRoutes}
        {protectedRoutes}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </LayoutWrapper>
  );
};
